// Module
var code = "<style>:host{display:block;height:400px;width:200px}.wrapper{display:flex;flex-direction:column;height:100%;width:100%}</style> <div class=\"wrapper\"></div>";
// Exports
export default code;